module.exports = __webpack_public_path__ + "img/teacher-image.a832b690.jpg";